function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(12.35 21.43)",
  clipPath: "url(#new-site_svg__a)"
}, /*#__PURE__*/React.createElement("clipPath", {
  id: "new-site_svg__a"
}, /*#__PURE__*/React.createElement("rect", {
  transform: "translate(5.65 -3.43)",
  x: -18,
  y: -16.5,
  rx: 0,
  ry: 0,
  width: 36,
  height: 33
})), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M1.901 4.207a.824.824 0 01-.536-.2L-2.43.655a.874.874 0 010-1.303l3.795-3.354a.808.808 0 011.164.104c.143.174.21.39.193.626a.857.857 0 01-.285.582L-.62.002l3.058 2.702a.885.885 0 01.092 1.208.838.838 0 01-.628.295z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(23.64 21.42)",
  clipPath: "url(#new-site_svg__b)"
}, /*#__PURE__*/React.createElement("clipPath", {
  id: "new-site_svg__b"
}, /*#__PURE__*/React.createElement("rect", {
  transform: "translate(-5.64 -3.42)",
  x: -18,
  y: -16.5,
  rx: 0,
  ry: 0,
  width: 36,
  height: 33
})), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M-1.9 4.217a.818.818 0 01-.627-.304.871.871 0 01-.193-.625.856.856 0 01.285-.583L.622.003l-3.057-2.702a.856.856 0 01-.285-.582.884.884 0 01.193-.626.818.818 0 01.628-.304c.192 0 .385.07.536.209L2.432-.648a.874.874 0 010 1.303l-3.795 3.354a.774.774 0 01-.536.208z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(17.84 21.47)",
  clipPath: "url(#new-site_svg__c)"
}, /*#__PURE__*/React.createElement("clipPath", {
  id: "new-site_svg__c"
}, /*#__PURE__*/React.createElement("rect", {
  transform: "translate(.16 -3.47)",
  x: -18,
  y: -16.5,
  rx: 0,
  ry: 0,
  width: 36,
  height: 33
})), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M-1.185 6.679a.797.797 0 01-.687-.391.905.905 0 01-.117-.643L.373-5.998c.084-.391.42-.678.805-.678.058 0 .117.009.167.017.444.096.73.548.637 1.017L-.38 6a.833.833 0 01-.804.678z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(18 18)",
  clipPath: "url(#new-site_svg__d)"
}, /*#__PURE__*/React.createElement("clipPath", {
  id: "new-site_svg__d"
}, /*#__PURE__*/React.createElement("rect", {
  x: -18,
  y: -16.5,
  rx: 0,
  ry: 0,
  width: 36,
  height: 33
})), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M-13.828 16.5c-2.295 0-4.172-1.946-4.172-4.336v-24.337c0-2.38 1.877-4.327 4.172-4.327H13.82c2.304 0 4.173 1.946 4.173 4.327v24.337c0 2.39-1.877 4.327-4.173 4.327h-27.647v.009zm0-31.288c-1.39 0-2.53 1.173-2.53 2.624v24.337c0 1.442 1.131 2.624 2.53 2.624H13.82c1.391 0 2.53-1.173 2.53-2.624v-24.346c0-1.442-1.13-2.624-2.53-2.624h-27.647v.009z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(18 10.88)",
  clipPath: "url(#new-site_svg__e)"
}, /*#__PURE__*/React.createElement("clipPath", {
  id: "new-site_svg__e"
}, /*#__PURE__*/React.createElement("rect", {
  transform: "translate(0 7.12)",
  x: -18,
  y: -16.5,
  rx: 0,
  ry: 0,
  width: 36,
  height: 33
})), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M-17.179.855c-.452 0-.821-.382-.821-.851 0-.47.369-.852.821-.852h34.35c.452 0 .82.383.82.852 0 .47-.368.851-.82.851h-34.35z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(10.25 6.65)",
  clipPath: "url(#new-site_svg__f)"
}, /*#__PURE__*/React.createElement("clipPath", {
  id: "new-site_svg__f"
}, /*#__PURE__*/React.createElement("rect", {
  transform: "translate(7.75 11.35)",
  x: -18,
  y: -16.5,
  rx: 0,
  ry: 0,
  width: 36,
  height: 33
})), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M.005 2.175C-1.152 2.175-2.09 1.2-2.09.002S-1.152-2.17.005-2.17c1.156 0 2.094.973 2.094 2.172 0 1.2-.938 2.173-2.094 2.173zm0-2.633a.455.455 0 00-.444.46c0 .252.2.46.444.46a.456.456 0 00.444-.46.45.45 0 00-.444-.46z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(4.56 6.63)",
  clipPath: "url(#new-site_svg__g)"
}, /*#__PURE__*/React.createElement("clipPath", {
  id: "new-site_svg__g"
}, /*#__PURE__*/React.createElement("rect", {
  transform: "translate(13.44 11.37)",
  x: -18,
  y: -16.5,
  rx: 0,
  ry: 0,
  width: 36,
  height: 33
})), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M-.002 2.168c-1.157 0-2.095-.973-2.095-2.172 0-1.199.938-2.172 2.095-2.172 1.156 0 2.094.973 2.094 2.172 0 1.2-.938 2.172-2.094 2.172zm0-2.632a.455.455 0 00-.444.46c0 .252.2.46.444.46a.455.455 0 00.444-.46.455.455 0 00-.444-.46z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(15.96 6.67)",
  clipPath: "url(#new-site_svg__h)"
}, /*#__PURE__*/React.createElement("clipPath", {
  id: "new-site_svg__h"
}, /*#__PURE__*/React.createElement("rect", {
  transform: "translate(2.04 11.33)",
  x: -18,
  y: -16.5,
  rx: 0,
  ry: 0,
  width: 36,
  height: 33
})), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M0 2.172c-1.156 0-2.095-.973-2.095-2.172 0-1.2.939-2.172 2.095-2.172 1.156 0 2.095.973 2.095 2.172 0 1.199-.939 2.172-2.095 2.172zM0-.461A.456.456 0 00-.444 0c0 .253.201.461.444.461A.456.456 0 00.444 0 .456.456 0 000-.46z"
})));

function SvgNewSite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36
  }, props), _ref);
}

export default SvgNewSite;